import { BasketballLeaguesSlice } from '@hefe/store';
import { Checkbox, Col, Row } from 'antd';
import { t } from '@hefe/i18n';
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../../store/store';

export default function AddLeagueAssistentSettings() {
  const dispatch = useAppDispatch();

  const [ownReferees, setOwnReferees] = useState(false);

  useEffect(() => {
    setSettings();
  }, [ownReferees]);

  const setSettings = () => {
    dispatch(
      BasketballLeaguesSlice.basketballLeaguesActions.setLeagueSettings({
        ownReferees,
      })
    );
  };

  return (
    <Row>
      <Col xs={24}>
        <Checkbox
          checked={ownReferees}
          onChange={(e) => setOwnReferees(e.target.checked)}
        >
          {t('leagues.assistant.settings.own_referees')}
        </Checkbox>
      </Col>
    </Row>
  );
}
